import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function LockerDonateRedirect() {
  const navigate = useNavigate();
  const { code } = useParams();

  useEffect(() => {
    const params = new URLSearchParams();
    if (code) params.set('share', code);
    params.set('dest', 'locker_room');
    navigate(`/sponsor-classroom/donate?${params.toString()}`, { replace: true });
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-shell/60 p-6">
      <div className="mx-auto max-w-2xl rounded-3xl bg-white/80 p-8 text-center text-cocoa/70 shadow-soft">
        Redirecting to donation page…
      </div>
    </div>
  );
}
